import { render, staticRenderFns } from "./holidayActMaleMain.vue?vue&type=template&id=6d497592&scoped=true"
import script from "./holidayActMaleMain.vue?vue&type=script&lang=js"
export * from "./holidayActMaleMain.vue?vue&type=script&lang=js"
import style0 from "./holidayActMaleMain.vue?vue&type=style&index=0&id=6d497592&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d497592",
  null
  
)

export default component.exports